import * as React from 'react';
import { IconProps } from './IconProps';
import { White } from '@traceair/tds';

const LargePlusIcon = ({ color = White, size = '32' }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 32 32" fill="none">
    <path
      d="M14.667 17.3332H8.00033C7.62255 17.3332 7.30588 17.2054 7.05033 16.9498C6.79477 16.6943 6.66699 16.3776 6.66699 15.9998C6.66699 15.6221 6.79477 15.3054 7.05033 15.0498C7.30588 14.7943 7.62255 14.6665 8.00033 14.6665H14.667V7.99984C14.667 7.62206 14.7948 7.30539 15.0503 7.04984C15.3059 6.79428 15.6225 6.6665 16.0003 6.6665C16.3781 6.6665 16.6948 6.79428 16.9503 7.04984C17.2059 7.30539 17.3337 7.62206 17.3337 7.99984V14.6665H24.0003C24.3781 14.6665 24.6948 14.7943 24.9503 15.0498C25.2059 15.3054 25.3337 15.6221 25.3337 15.9998C25.3337 16.3776 25.2059 16.6943 24.9503 16.9498C24.6948 17.2054 24.3781 17.3332 24.0003 17.3332H17.3337V23.9998C17.3337 24.3776 17.2059 24.6943 16.9503 24.9498C16.6948 25.2054 16.3781 25.3332 16.0003 25.3332C15.6225 25.3332 15.3059 25.2054 15.0503 24.9498C14.7948 24.6943 14.667 24.3776 14.667 23.9998V17.3332Z"
      fill={color}
    />
  </svg>
);

export default LargePlusIcon;
